/**
 * /alocare-ip + /alocare-as — migrated from public/js/lir-ip.js.
 *
 * 1. Input focus/blur .lb-focused
 * 2. .btn-request-fixed → scroll to forms
 * 3. .switch-btn → animate .sum fade-out + fade-in
 * 4. .btn-request → slideDown form by data-id
 * 5. #request-ip4, #request-ip6, #request-as — Form() calls (no-op via shim
 *    pentru form-uri cu method=post+action; vezi MessageController care
 *    proceseaza native PRG)
 * 6. .layer-terms accordion
 */
import { Resort } from '../core/resort.js';

new Resort((rt) => {
    /* Inputs focus/blur */
    $('input[type="text"], textarea', true).on('focus', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p && !p.classList.contains('lb-focused')) p.classList.add('lb-focused');
    });
    $('input[type="text"], textarea', true).on('blur', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p?.classList.contains('lb-focused')) p.classList.remove('lb-focused');
    });

    /* Fixed request button — smooth scroll to forms */
    ($('section') as Element | null)?.on('click', '.btn-request-fixed', () => {
        const row = $('.layer-1 .row') as Element | null;
        if (row) window.scrollTo({ top: row.offset().top - 20, behavior: 'smooth' });
    });

    /* Switch sums in layer-1 */
    let switchReady = true;
    ($('.layer-1 .switch-btn') as Element | null)?.on('click', 'a', function (this: Element) {
        if (!switchReady) return;
        switchReady = false;
        if (this.classList.contains('active')) { switchReady = true; return; }
        ($('.layer-1 .switch-btn a.active') as Element | null)?.classList.remove('active');
        this.classList.add('active');
        const target = this;
        const targetId = (target as HTMLElement).dataset['id'];

        $('.layer-1 .row .sum.active', (active: Element) => {
            active.classList.add('fade-out-fast');
            active.addEventListener('animationend', function (this: Element, e: Event) {
                e.stopPropagation();
                this.classList.remove('active', 'fade-out-fast');
                $(`.layer-1 .row .sum[data-id="${targetId}"]`, (layer: Element) => {
                    layer.classList.add('active', 'fade-in-fast');
                    layer.addEventListener('animationend', function (this: Element, e2: Event) {
                        e2.stopPropagation();
                        this.classList.remove('fade-in-fast');
                        switchReady = true;
                    }, { once: true });
                    return true;
                });
            }, { once: true });
            return true;
        });
    });

    /* btn-request → slideDown form */
    ($('.layer-1') as Element | null)?.on('click', 'a.btn-request', function (this: Element) {
        (this as HTMLElement).style.display = 'none';
        const id = (this as HTMLElement).dataset['id'];
        ($(`#request-${id}`) as HTMLElement | null)?.slideDown();
    });

    const is_en = /\/en\//.test(window.location.href);

    const rules = {
        company: 'min(5)max(40)',
        name:    'min(5)max(40)',
        email:   'mail(40)',
        phone:   'min(10)max(30)',
        address: 'min(3)max(40)',
    };

    const formIds: Array<{ id: string; method: string }> = [
        { id: '#request-ip4', method: 'lir_ip_send_request' },
        { id: '#request-ip6', method: 'lir_ip_send_request' },
        { id: '#request-as',  method: 'lir_as_send_request' },
    ];

    formIds.forEach(({ id, method }) => {
        const form = $(id) as HTMLFormElement | null;
        form?.Form('form', method, {}, {
            valid: () => rules,
            done: (r: unknown) => {
                if (r === 'Done') {
                    rt.notify(is_en ? 'Your request was sent successfully.' : 'Cererea ta a fost expediată cu succes.');
                    form.reset();
                }
            },
        });
    });

    /* Terms accordion */
    ($('.layer-terms') as Element | null)?.on('click', 'h2', function (this: Element) {
        this.classList.toggle('active');
        ($('.layer-terms .wrapper') as HTMLElement | null)?.slideToggle();
    });
});
